import urls from './urls';
import axios from 'axios';
import {addParamsToQueryString} from '../functions/utils';
import config from "../libs/webIMConfig";

class locationApi {
    static locationAutoComplete(params) {
        // this.restClient = new RestClient();
        // this.restClient.setBaseUrl(urls.BASE_RHPURL);
        // const queryString = Object.keys(params)
        //   .map(key => `${key}=${params[key]}`)
        //   .join('&');
        // const url = `${urls.RHP_GET_AUTOCOMPLETE_LOCATION}${queryString ? '?' : ''}${queryString}`;
        const url = addParamsToQueryString(urls.RHP_GET_AUTOCOMPLETE_LOCATION, params);
        // return this.restClient.execute(url, ApiMethod.GET, null, false, false, true).then(res => res);
        return axios.get(url, {
            baseURL: urls.BASE_RHPURL,
            headers: {isAnonymous: !config.rhpToken, isAnonymousAccessToken: !config.rhpToken}
        }).then(res => res);
    }

    static getLocation(countryId) {
        const url = `${urls.RHP_GET_LOCATION}${countryId ? '/' + countryId : ''}`;
        return axios.get(url, {
            baseURL: urls.BASE_RHPURL,
            headers: {isAnonymous: !config.rhpToken, isAnonymousAccessToken: !config.rhpToken}
        }).then(res => res);
    }
}

export default locationApi;
